import { ReactNode } from 'react';

import { cn } from 'helpers/classnames';
import { ImageProps, LazyImage } from 'components/common/Image';

import css from 'styles/components/common/card/cardMedia.scss';

interface CardMediaProps {
  imageIndex?: number;
  imageClassName?: string;
  isHovered?: boolean;
  mainImage: ImageProps;
  hoverImage?: ImageProps;
  children?: ReactNode;
  className?: string;
  forceLoadIndex?: number;
  imageNoBackground?: boolean;
  fullSizeImage?: boolean;
  onHover?: () => void;
  disableHoverImage?: boolean;
}

const CardMedia = ({
  className,
  imageIndex,
  imageClassName,
  isHovered,
  mainImage,
  hoverImage,
  forceLoadIndex,
  imageNoBackground = false,
  fullSizeImage = false,
  onHover,
  disableHoverImage = false,
  children
}: CardMediaProps) => {
  const forceLoad = imageIndex !== undefined && forceLoadIndex !== undefined && imageIndex < forceLoadIndex;

  if (isHovered && onHover) {
    onHover();
  }

  return (
    <div
      className={cn(
        className,
        css.imageWrapper,
        { [css.hovered]: !disableHoverImage && isHovered && hoverImage?.src },
        // .imageNoBackground exists but is nested under a :not() which the linter
        // has trouble reading.
        // eslint-disable-next-line css-modules/no-undef-class
        { [css.imageNoBackground]: imageNoBackground }
      )}
    >
      {children}
      <figure>
        <meta itemProp="image" content={mainImage.src} />
        <LazyImage forceLoad={forceLoad} className={cn(css.mainImage, { [css.fullSizeImage]: fullSizeImage }, imageClassName)} {...mainImage} />
        {hoverImage && <LazyImage forceLoad={forceLoad} className={cn(css.hoverImage, imageClassName)} {...hoverImage} />}
      </figure>
    </div>
  );
};

export default CardMedia;
